import { Outlet } from 'react-router-dom';
import { ThemeApplier } from '@/lib/prefs/usePrefsStore';

export function PublicShell() {
  return (
    <div className="min-h-screen bg-[var(--color-bg-primary)]">
      <ThemeApplier />
      <Outlet />
    </div>
  );
}
